import RobotImage from '../RobotImage/RobotImage'
import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'

import RobotAdditionalInfo from './RobotAdditionalInfo/RobotAdditionalInfo'
import RobotInfo from './RobotInfo/RobotInfo'
import RobotMissionMainStatus from './RobotMissionMainStatus/RobotMissionMainStatus'

import style from './RobotDetails.module.css'

const RobotDetails = () => {
  const robot = useSelector(selectRobot)

  return (
    <div className={style.root}>
      <div className={style.tableWrapper}>
        <RobotMissionMainStatus />
        <RobotInfo />
      </div>
      <RobotAdditionalInfo />
    </div>
  )
}

export default RobotDetails
